export const MAX_BOOKING_RESCHEDULES = 2;

export function canRescheduleBooking(booking) {
  if (!booking) return false;
  if (booking.can_reschedule === false) return false;
  const count = booking.reschedule_count ?? 0;
  return count < MAX_BOOKING_RESCHEDULES;
}

export const RESCHEDULE_LIMIT_MESSAGE =
  'لا يمكن تغيير الموعد أكثر من مرتين. يمكنك إلغاء الحجز فقط.';
